import { Id } from "@teachloop/backend/_generated/dataModel";
import React, { createContext, ReactNode, useContext, useMemo } from "react";

type ChatItem = {
  _id: Id<"chatsMessages">;
  content?: string;
  fileUrl?: string | null;
  fileName?: string;
  fileType?: string;
  sentBy: {
    _id: Id<"users">;
    name: string;
  };
  createdAt: number;
  isMe: boolean;
  showDate: boolean;
};

const ChatItemContext = createContext<ChatItem | undefined>(undefined);

export function useChatItem() {
  const context = useContext(ChatItemContext);
  if (!context) {
    throw new Error("useChatItem must be used within a ChatItemProvider");
  }
  return context;
}

function ChatItemProvider({
  children,
  chatItem,
}: {
  children: ReactNode;
  chatItem: ChatItem;
}) {
  return (
    <ChatItemContext.Provider value={useMemo(() => chatItem, [chatItem])}>
      {children}
    </ChatItemContext.Provider>
  );
}

export default ChatItemProvider;
